import React from 'react'

const BannerImage = ({ children, textLink, link, className, textButton, linkButton }) => {
    return (
        <div className='mc-bannerImage'>
            <div className={className}>
                <div className='text'>
                    <div>
                        {children}
                    </div>
                    {textButton && <a href={linkButton}><button className='buttonBanner' >{textButton}</button></a>}
                    <div className='link'>
                        <a href={link} style={{color : '#FDF2F8'}}>{textLink}</a>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    )
}

export default BannerImage
